import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import CardanoHero from "./CardanoHero";
import WhyChCardano from "./WhyChCardano";
import CardanoDApp from "./CardanoDApp";
import BenefitsOFCardano from "./BenefitsOFCardano";

function Cardano() {
  return (
    <div>
      <Header />
      <CardanoHero />
      <WhyChCardano />
      <CardanoDApp />
      <BenefitsOFCardano />
      <Footer />
    </div>
  );
}

export default Cardano;
